import { combineReducers } from "redux";
import { slidesMetaData } from "./slidesMetaData";
import { autoSave } from "./autoSave";
import { slideList } from "./slideList";
import { editorState } from "./editorState";
import { designMode } from "./designMode";

export default combineReducers({
	slidesMetaData,
	autoSave,
	slideList,
	editorState,
	designMode,
});
